var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextMonthsIncome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_66007)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08096 1.82788H4.36768",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6325 1.82788H12.9192",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_66007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_66007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24219 19.1531H0.390625V1.82768H2.80508",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1949 1.82768H19.6094V19.1531H11.7578",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 19.1531C10.3906 19.3688 10.2157 19.5437 10 19.5437C9.78426 19.5437 9.60938 19.3688 9.60938 19.1531C9.60938 18.9374 9.78426 18.7625 10 18.7625C10.2157 18.7625 10.3906 18.9374 10.3906 19.1531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3566 1.82764H8.64331",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.390625 4.95264H19.6094",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9192 3.39014H11.3567V0.846583H12.9192V3.39014Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64331 3.39014H7.08081V0.846583H8.64331V3.39014Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1948 3.39014H15.6323V0.846583H17.1948V3.39014Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36768 3.39014H2.80518V0.846583H4.36768V3.39014Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 12.0527C9.39998 12.0527 8.91357 11.5663 8.91357 10.9664C8.91357 10.3664 9.39998 9.88 9.99994 9.88C10.4201 9.88 10.7846 10.1186 10.9653 10.4676",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.88013V9.08411",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.0529C10.6 12.0529 11.0864 12.5392 11.0864 13.1392C11.0864 13.7392 10.6 14.2256 10 14.2256C9.57982 14.2256 9.21537 13.987 9.03467 13.638",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2255V15.0215",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 8.46826H2.34375V6.90576H3.90625V8.46826Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 17.2002H2.34375V15.6377H3.90625V17.2002Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 12.834H2.34375V11.2715H3.90625V12.834Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 8.46826H16.0938V6.90576H17.6562V8.46826Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 17.2002H16.0938V15.6377H17.6562V17.2002Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 12.834H16.0938V11.2715H17.6562V12.834Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3359 8.46826H12.7734V6.90576H14.3359V8.46826Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3359 17.2002H12.7734V15.6377H14.3359V17.2002Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 8.46826H5.66406V6.90576H7.22656V8.46826Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 17.2002H5.66406V15.6377H7.22656V17.2002Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 12.0527C14.5312 14.5553 12.5025 16.584 10 16.584C7.49746 16.584 5.46875 14.5553 5.46875 12.0527C5.46875 9.5502 7.49746 7.52149 10 7.52149C12.5025 7.52149 14.5312 9.5502 14.5312 12.0527Z",
    stroke: "white",
    strokeWidth: 0.976562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_66007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMonthsIncome);
export default __webpack_public_path__ + "static/media/nextMonthsIncome.14dc23a09fb279cbe8b07cf4e92effd2.svg";
export { ForwardRef as ReactComponent };